import {createContext} from 'react';
import type {EventBus} from '@/common/helpers/utils/EventBus';

export interface AdRefreshContextValue {
	//
	/**
	 * All banners refresh event trigger
	 */
	onRefresh: EventBus<void>;
}

export const AdRefreshContext = createContext<AdRefreshContextValue | null>(null);
AdRefreshContext.displayName = 'AdRefreshContext';
